module.exports = "<input #fileUpload ngFileSelect type=\"file\" [options]=\"fileUploaderOptions\" (onUpload)=\"_onFileUpload($event)\" (beforeUpload)=\"beforeFileUpload($event)\" hidden=\"true\">\r\n<div class=\"input-group\" [ngClass]=\"{uploading: uploadFileInProgress}\">\r\n    <input #inputText type=\"text\" [value]=\"defaultValue\" class=\"form-control\" readonly>\r\n    <span class=\"input-group-btn\">\r\n      <button class=\"btn btn-success\" type=\"button\" (click)=\"bringFileSelector();\">Browse</button>\r\n  </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baFileUploader/baFileUploader.html
// module id = 1581
// module chunks = 18